import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ScheduledPaymentUi } from '../../components/main/payments/models/scheduled-payment-ui';
import { Store } from '@ngxs/store';
import { SettingsState } from '../../components/main/settings/state';
import { takeUntil, tap } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class ScheduledPaymentsService implements OnDestroy {
  private readonly _unsubscribe$ = new Subject<void>();

  dataSourceScheduledPayments = new MatTableDataSource<ScheduledPaymentUi>();

  scheduledPaymentsLoaded$ = new Subject<void>();

  scheduledPaymentsMonitor$: Observable<ScheduledPaymentUi[]> = this.store.select(SettingsState.getScheduledPayments).pipe(
    tap(scheduledPayments => this.dataSourceScheduledPayments.data = scheduledPayments),
    takeUntil(this._unsubscribe$),
  )

  constructor(private readonly store: Store) {
    this.scheduledPaymentsMonitor$.subscribe();
  }

  /**
   * Aids search bar filtration.
   * @param data
   * @param filter
   */
  searchFilterFunction(data: ScheduledPaymentUi, filter: string): boolean {
    return data.client.name.toLowerCase().includes(filter)
      || data.paymentPlan.name.toLowerCase().includes(filter)
      || data.paymentPlan.last4?.toLowerCase().includes(filter)
      || data.paymentPlan.cardType?.toLowerCase().includes(filter)
      || `${data.getAmountDisplay()}`.toLowerCase().includes(filter)
      || (data.getAmountDisplay() !== 'Pending' && `$${data.getAmountDisplay()}`.toLowerCase().includes(filter))
      || data.actionDefInstanceDTO.status.toLowerCase().includes(filter)
  };

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
